// vuex
import { mapMutations, mapState } from 'vuex'

// constants
import { SIDE_NAV, DATE_FORMAT } from '@/constants'

// components
import maSideNav from './components/sidenav'

// Components
import maDatePicker from '@/components/datePicker'
import maInputBtn from '@/components/input/modules/btn'
import maInputText from '@/components/input/modules/text'
import maInputRadio from '@/components/input/modules/radio'
import maInputSelect from '@/components/input/modules/select'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maInputNumber from '@/components/input/modules/number'
import maCounter from '@/components/counter'
import maModal from '@/components/modal'

import { apiPostAdditionalInfo } from '@/services/API/additionalInfo'

import { UPDATE_LOADER, WARRANTY_MODULE_NAME } from '@/store/types'

/**
 * @module
 * @name Extra Infi
 * @description Displays the extra info form asociated to a claim
 */
export default {
  name: 'extraInfoLayout',
  components: {
    maDatePicker,
    maInputNumber,
    maInputBtn,
    maInputText,
    maInputSelect,
    maInputCheckbox,
    maInputRadio,
    maSideNav,
    maCounter,
    maModal
  },
  computed: {
    ...mapState({
      stateUserRoutes: state => state.user.routes || []
    }),
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantySecondaryId: 'secondaryId'
    }),
    sinisterId: function() {
      return `- Sinistre ${this.stateWarrantySinisterId}`
    },
    isMoreInfoSendButtonEnabled: function() {
      const franchiseGenerale = (this.extraInfo.franchiseGenerale ||
        this.extraInfo.franchiseMontantLibre)

      return (
        this.extraInfo.firstName &&
        this.extraInfo.lastName &&
        this.extraInfo.email &&
        this.extraInfo.sinisterAddress &&
        this.extraInfo.date &&
        this.extraInfo.police &&
        this.extraInfo.validContract &&
        this.extraInfo.scoreAsk &&
        franchiseGenerale != null &&
        this.extraInfo.currentClaim &&
        this.extraInfo.litigationAlertAbsence &&
        this.extraInfo.sinisterCause &&
        this.extraInfo.sinisterPlace &&
        this.extraInfo.damagePlace &&
        this.extraInfo.causeRepaired &&
        this.stateWarrantySinisterId
      )
    },
    maxDate: function() {
      return new Date()
    },

    dateFormat: function() {
      return DATE_FORMAT
    }
  },

  data: function() {
    return {
      dataUserRoutes: [],
      isInIframe: false,
      extraInfo: {
        firstName: null,
        lastName: null,
        email: null,
        sinisterAddress: null,
        date: null,
        police: null,
        validContract: null,
        scoreAsk: null,
        franchiseGenerale: null,
        franchiseMontantLibre: null,
        optionalValues: {
          piscine: null,
          exterieur: null,
          optionRAN: null
        },
        currentClaim: null,
        litigationAlertAbsence: null,
        gagNumber: 0,
        renNumber: 0,
        sinisterCause: null,
        sinisterPlace: null,
        damagePlace: null,
        causeRepaired: null,
        thirdPartyInvolved: null
      },
      moreInfoSinisterCauseOptions: [
        {
          key: 'ruptureCanalisation',
          literal: 'Fuite rupture canalisation privée accessible',
          agent_icon: 'ico-pipe'
        },
        {
          key: 'baignoire',
          literal: 'Fuite/rupture appareil \u00E0 effet d\u1FFDeau',
          agent_icon: 'ico-bath-2'
        },
        {
          key: 'infiltrationToiture',
          literal: 'Infiltration toiture-terrasse',
          agent_icon: 'ico-roof'
        },
        {
          key: 'infiltrationMurs',
          literal: 'Infiltration par fa\u00E7ade',
          agent_icon: 'ico-leak'
        },
        {
          key: 'autres',
          literal: 'A déterminer',
          agent_icon: 'ico-others-2'
        }
      ],
      validContractOptions: [
        {
          key: 'oui',
          literal: 'Oui'
        },
        {
          key: 'non',
          literal: 'Non'
        }
      ],
      scoreAskOptions: [
        {
          key: 'vert',
          literal: 'Vert'
        },
        {
          key: 'orange',
          literal: 'Orange'
        },
        {
          key: 'rouge',
          literal: 'Rouge'
        }
      ],
      franchiseOptions: [
        {
          key: '0',
          literal: '0€'
        },
        {
          key: '139',
          literal: '139€'
        },
        {
          key: '225',
          literal: '225€'
        },
        {
          key: '280',
          literal: '280€'
        },
        {
          key: '380',
          literal: '380€'
        },
        {
          key: '480',
          literal: '480€'
        },
        {
          key: '680',
          literal: '680€'
        },
        {
          key: '800',
          literal: '800€'
        },
        {
          key: '1000',
          literal: '1000€'
        },
        {
          key: '1500',
          literal: '1500€'
        }
      ],
      franchiseMontantLibre: {
        min: 0,
        max: 5000
      },
      sinisterPlaceOptions: [
        {
          key: 'Interieur',
          literal: 'Chez moi'
        },
        {
          key: 'PasDeChezMoi',
          literal: 'Pas chez moi'
        },
        {
          key: 'SaisPas',
          literal: 'Je ne sais pas'
        }
      ],
      damagePlaceOptions: [
        {
          key: 'ChezMoi',
          literal: 'Chez moi'
        },
        {
          key: 'ChezMoiVoisin',
          literal: 'Chez moi et mon voisin'
        },
        {
          key: 'PasChezMoi',
          literal: 'Les dégâts ne sont pas chez moi'
        }
      ],
      causeRepairedOptions: [
        {
          key: 'Oui',
          literal: 'Oui'
        },
        {
          key: 'Non',
          literal: 'Non'
        },
        {
          key: 'SaisPas',
          literal: 'Je ne sais pas'
        }
      ]
    }
  },
  methods: {
    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),
    checkRoutes: function(routes) {
      routes.forEach(route => {
        // add
        const routeMetaType = route.meta.type

        if (routeMetaType.indexOf(SIDE_NAV) >= 0) {
          this.dataUserRoutes.push(route)
        }

        // has childrens? call again
        if (route.children) {
          this.checkRoutes(route.children)
        }
      })
    },
    handleMultipleCheckbox(event) {
      this.extraInfo.optionalValues.piscine = event.piscine
      this.extraInfo.optionalValues.exterieur = event.exterieur
      this.extraInfo.optionalValues.optionRAN = event.optionRAN
    },
    handleInIframeClass() {
      const isInFnolFlow = this.FNOLFlow.isExecuting
      const isInIgnitionIframe = this.FNOLFlow.isIgnitionPlatform

      if (isInFnolFlow || isInIgnitionIframe) {
        this.isInIframe = true
      }
    },
    warrantyBack() {
      const sinisterId = this.stateWarrantySinisterId
      const complementaryRef = this.stateWarrantySecondaryId
      this.$router.push({
        name: 'warranty',
        params: { sinisterId, complementaryRef }
      })
    },
    transformBooleanToYesNoOption(value) {
      if (value) {
        return 'oui'
      }

      return 'non'
    },
    transformYesNoOptionToBoolean(value) {
      return value === 'oui'
    },
    sendAditionalInfo() {
      this.updateLoader(true)
      const franchiseGenerale = parseInt(
        this.extraInfo.franchiseGenerale != null
          ? this.extraInfo.franchiseGenerale
          : this.extraInfo.franchiseMontantLibre
      )

      apiPostAdditionalInfo({
        IDsinistre: this.stateWarrantySinisterId,
        PrenomAssure: this.extraInfo.firstName,
        NomAssure: this.extraInfo.lastName,
        MailAssure: this.extraInfo.email,
        AdresseAssure: this.extraInfo.sinisterAddress,
        DATSIN: this.extraInfo.date,
        NumPolice: this.extraInfo.police,
        ValiditeContrat: this.extraInfo.validContract,
        ScoreFraude: this.extraInfo.scoreAsk,
        Franchise: franchiseGenerale,
        Fran_Spe_NonCatnat: 0,
        Fran_Spe_Eau: 0,
        OptionPiscine: this.transformBooleanToYesNoOption(
          this.extraInfo.optionalValues.piscine
        ),
        OptionAmExt: this.transformBooleanToYesNoOption(
          this.extraInfo.optionalValues.exterieur
        ),
        OptionRAN: this.transformBooleanToYesNoOption(
          this.extraInfo.optionalValues.optionRAN
        ),
        AbsenceSinistre: this.extraInfo.currentClaim,
        Flag_CTX: this.transformYesNoOptionToBoolean(
          this.extraInfo.litigationAlertAbsence
        ),
        NombreGAG: this.extraInfo.gagNumber ? this.extraInfo.gagNumber : 0,
        NombreREN: this.extraInfo.renNumber ? this.extraInfo.renNumber : 0,
        GDC: this.extraInfo.sinisterCause,
        Origine: this.extraInfo.sinisterPlace,
        LocDegats: this.extraInfo.damagePlace,
        CauseRep: this.extraInfo.causeRepaired,
        TiersIdentifie: this.extraInfo.thirdPartyInvolved || undefined
      })
        .then(() => {
          this.updateLoader(false)
          this.$router.push({
            path: `/warranty/GenImmo/all/${this.$route.params.sinisterId}?openLinkModal=${true}`
          })
        })
        .catch(() => {
          this.updateLoader(false)
          this.throwNotification(
            this.$t('warrantyProps.moreInfoModal.sendError'),
            '',
            'KO'
          )
        })
    },
    handleChangeSinisterDate(date) {
      this.extraInfo.date = date
    }
  },
  watch: {
    stateUserRoutes() {
      this.dataUserRoutes = []
      this.checkRoutes(this.stateUserRoutes)
    }
  },
  beforeMount: function() {
    this.dataUserRoutes = []
    this.checkRoutes(this.stateUserRoutes)
    this.handleInIframeClass()
  },
  mounted: function() {
    document.querySelector('body').style.overflow = 'visible'
  }
}
